import script from "./myList.vue?vue&type=script&setup=true&lang=js"
export * from "./myList.vue?vue&type=script&setup=true&lang=js"

import "./myList.vue?vue&type=style&index=0&id=bae2c5e4&lang=scss&scoped=true"

import exportComponent from "/Users/luoxuelin/Workspace/idea/wnzhfc/s-pages/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bae2c5e4"]])

export default __exports__